import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Header from './Components/Header/index'
import ProductDetail from './Components/ProductDetail/index'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

function App() {
  return (
    <Router>
      <div className="App">

        <Header />
        <Switch>
          <Route path="/" exact>
            <ProductDetail />
          </Route>
          <Route path="/product-detail" exact>
            <ProductDetail />
          </Route>
          <Route path="/:open" exact>
            <ProductDetail isOpen />
          </Route>
        </Switch>
        <footer class="section-footer border-top padding-y">
          <div class="container">
            <p class="float-md-right">
              &copy; Copyright 2021 All rights reserved
      </p>
            <p>
              <a href="#">Terms and conditions</a>
            </p>
          </div>
        </footer>
      </div>

    </Router>
  );
}
export default App;
